import { render } from "./SavedTablesList.vue?vue&type=template&id=88f284e0"
import script from "./SavedTablesList.vue?vue&type=script&lang=js"
export * from "./SavedTablesList.vue?vue&type=script&lang=js"

import "./SavedTablesList.vue?vue&type=style&index=0&id=88f284e0&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInnerLoading});
